import { render } from "./TvmPageRedirectComponent.vue?vue&type=template&id=94fea1a8"
import script from "./TvmPageRedirectComponent.vue?vue&type=script&lang=js"
export * from "./TvmPageRedirectComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__